<script setup>
import { computed, ref } from 'vue'
import { dias, fecha, money } from '../lib/format.js'

const props = defineProps({
  leads: { type: Array, required: true },
  locationId: { type: String, default: '' },
  pageSize: { type: Number, default: 25 },
  showPipeline: { type: Boolean, default: false },
})

const visibles = ref(props.pageSize)
const mostrados = computed(() => props.leads.slice(0, visibles.value))
const restantes = computed(() => Math.max(0, props.leads.length - visibles.value))

/** Enlace directo a la ficha del contacto dentro del CRM. */
function crmUrl(lead) {
  if (!props.locationId || !lead.contactId) return null
  return `https://app.gohighlevel.com/v2/location/${props.locationId}/contacts/detail/${lead.contactId}`
}
</script>

<template>
  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>Lead</th>
          <th v-if="showPipeline">Pipeline</th>
          <th>Etapa</th>
          <th class="right nowrap">Sin avanzar</th>
          <th class="right nowrap">Inactivo</th>
          <th class="right">Valor</th>
          <th>Responsable</th>
          <th>Motivos</th>
          <th class="nowrap">Creado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="l in mostrados" :key="l.key">
          <td>
            <a v-if="crmUrl(l)" :href="crmUrl(l)" target="_blank" rel="noopener" class="nombre">{{ l.name }}</a>
            <span v-else class="nombre">{{ l.name }}</span>
            <div class="muted contacto">{{ l.email || l.phone || 'sin datos de contacto' }}</div>
          </td>
          <td v-if="showPipeline" class="muted">{{ l.pipelineName }}</td>
          <td>
            {{ l.stageName }}
            <div class="muted contacto">{{ l.kind }}</div>
          </td>
          <td class="right mono">{{ dias(l.daysStuck) }}</td>
          <td class="right mono">{{ dias(l.daysInactive) }}</td>
          <td class="right mono">{{ l.value ? money(l.value) : '-' }}</td>
          <td :class="{ muted: !l.assignedTo }">{{ l.assignedTo || 'sin asignar' }}</td>
          <td>
            <span
              v-for="r in l.reasons" :key="r.id"
              class="badge" :class="'sev-' + l.severity" :title="r.detail"
            >{{ r.label }}</span>
          </td>
          <td class="muted nowrap">{{ fecha(l.createdAt) }}</td>
        </tr>
        <tr v-if="!leads.length">
          <td :colspan="showPipeline ? 9 : 8" class="empty">Ningun lead cumple los criterios con los filtros actuales.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="restantes" class="row masfilas no-print">
    <button class="ghost" @click="visibles += pageSize">Ver {{ Math.min(restantes, pageSize) }} mas</button>
    <button class="ghost" @click="visibles = leads.length">Ver los {{ restantes }} restantes</button>
  </div>
</template>

<style scoped>
.nombre { font-weight: 600; color: var(--text); text-decoration: none; }
a.nombre:hover { color: var(--accent); text-decoration: underline; }
.contacto { font-size: 11.5px; }
.badge { margin: 0 4px 3px 0; }
.masfilas { justify-content: center; padding: 8px; }
</style>
